import { languageMap } from "../../constants/language.js";
import isEmpty from "lodash/isEmpty";
import { HttpError } from "../../types/HttpError.js";
import { cachingFetcher } from "./cachingFetcher.js";
import { STORE_IDS } from "../../components/PaymentCard/PaymentCardInfoEditor/PaymentCardInfoEditorUI/constants.js";
import { openingDate } from "./openingDate.js";
import { round } from "./round.js";
const DEFAULT_TIMEOUT = 3e4;
let agent = null;
const getAgent = (environment) => {
  if (agent) {
    return agent;
  }
  agent = {
    addToListLegacy: ({
      clientIdLegacy,
      itemNumber,
      listId,
      listName,
      locale,
      localeModuleKey,
      operationName,
      quantity
    }) => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      const url = (_b = (_a = environment == null ? void 0 : environment.api) == null ? void 0 : _a.addToListLegacy) == null ? void 0 : _b.endpoint;
      const langId = Object.keys(languageMap).find((key) => languageMap[key] === locale);
      const body = {
        ...(_d = (_c = environment == null ? void 0 : environment.api) == null ? void 0 : _c.addToListLegacy) == null ? void 0 : _d.requiredRequestParameters,
        authToken: encodeURIComponent(clientIdLegacy),
        langId: langId || "-1",
        operationName,
        storeId: STORE_IDS[localeModuleKey.toUpperCase()]
      };
      if (listId !== void 0) {
        body.listId = listId;
        body.requisitionListId = listId;
      }
      if (listName !== void 0) {
        body.listidname = listName;
        body.name = listName;
      }
      if (operationName === "AddNewWishList") {
        body.requisitionListId = "-1001";
      }
      if (itemNumber !== void 0) {
        body.partNumber = itemNumber;
      }
      if (quantity !== void 0) {
        body.quantity = quantity;
      }
      const formBody = new URLSearchParams();
      Object.entries(body).forEach(([key, value]) => {
        formBody.append(
          key,
          typeof value === "object" ? JSON.stringify(value) : String(value)
        );
      });
      const requestInit = {
        body: formBody.toString(),
        credentials: "include",
        headers: (_f = (_e = environment == null ? void 0 : environment.api) == null ? void 0 : _e.addToListLegacy) == null ? void 0 : _f.headers,
        method: (_h = (_g = environment == null ? void 0 : environment.api) == null ? void 0 : _g.addToListLegacy) == null ? void 0 : _h.method
      };
      return cachingFetcher(
        url,
        requestInit,
        environment.api.addToListLegacy.timeout,
        false
      ).then((resp) => resp);
    },
    addToExistingList: (authCookie, quantity, itemNumber, listId, localeModuleKey) => {
      if (!localeModuleKey) {
        throw new Error("locale Module key has to be passed");
      }
      if (!authCookie) {
        throw new Error("Authorization cookie has to be passed");
      }
      const url = environment.api.addToExistingList.endpoint.replace(
        "{listId}",
        listId
      );
      const clientid = environment.api.addToExistingList.headers["client-id"][localeModuleKey];
      const body = {
        ...environment.api.addToExistingList.body,
        comment: "",
        itemNumber,
        quantity
      };
      const requestInit = {
        body: JSON.stringify(body),
        headers: {
          ...environment.api.addToExistingList.headers,
          Authorization: authCookie,
          "client-id": clientid
        },
        method: "POST"
      };
      return cachingFetcher(
        url,
        requestInit,
        environment.api.addToExistingList.timeout,
        false
      ).then((resp) => resp);
    },
    addToNewList: (authCookie, quantity, itemNumber, listName, localeModuleKey) => {
      if (!localeModuleKey) {
        throw new Error("locale Module key has to be passed");
      }
      if (!authCookie) {
        throw new Error("Authorization cookie has to be passed");
      }
      const url = environment.api.addToNewList.endpoint;
      const clientid = environment.api.addToNewList.headers["client-id"][localeModuleKey];
      const body = {
        ...environment.api.addToNewList.body,
        description: "",
        items: [
          {
            itemNumber,
            quantity
          }
        ],
        title: listName
      };
      const requestInit = {
        body: JSON.stringify(body),
        headers: {
          ...environment.api.addToNewList.headers,
          Authorization: authCookie,
          "client-id": clientid
        },
        method: "POST"
      };
      return cachingFetcher(
        url,
        requestInit,
        environment.api.addToNewList.timeout,
        false
      ).then((resp) => resp);
    },
    // NEW API
    createNewWishList: async (authCookie, title, localeModuleKey) => {
      var _a, _b, _c, _d;
      if (!localeModuleKey) {
        throw new Error("locale Module key has to be passed");
      }
      if (!authCookie) {
        throw new Error("Authorization cookie has to be passed");
      }
      const url = (_b = (_a = environment == null ? void 0 : environment.api) == null ? void 0 : _a.addToNewList) == null ? void 0 : _b.endpoint;
      const clientid = (_d = (_c = environment == null ? void 0 : environment.api) == null ? void 0 : _c.addToNewList) == null ? void 0 : _d.headers["client-id"][localeModuleKey];
      const body = JSON.stringify({
        description: "",
        title,
        type: "WishList"
      });
      const requestInit = {
        body,
        headers: {
          ...environment.api.addToNewList.headers,
          Authorization: authCookie,
          "client-id": clientid,
          accept: "application/json"
        },
        method: "POST"
      };
      try {
        const response = await fetch(url, requestInit);
        if (!response.ok) {
          if ((response == null ? void 0 : response.status) === 403) {
            return {
              status: "error",
              message: "Prohibited"
            };
          } else if ((response == null ? void 0 : response.status) === 409) {
            return {
              status: "error",
              message: "Duplicate"
            };
          } else {
            return {
              status: "error",
              message: "Default"
            };
          }
        }
        const jsonResponse = await response.json();
        jsonResponse.status = "success";
        jsonResponse.message = "List created successfully";
        return jsonResponse;
      } catch (error) {
        if (error instanceof DOMException && error.name === "AbortError") {
          throw new Error(`Request aborted: ${error.message}`);
        }
        throw error;
      }
    },
    //  NEW LIST API
    fetchWishLists: async (authCookie, localeModuleKey) => {
      var _a, _b, _c, _d, _e, _f;
      if (!localeModuleKey) {
        throw new Error("locale Module key has to be passed");
      }
      if (!authCookie) {
        throw new Error("Authorization cookie has to be passed");
      }
      const url = (_b = (_a = environment == null ? void 0 : environment.api) == null ? void 0 : _a.addToNewList) == null ? void 0 : _b.endpoint;
      const clientid = (_d = (_c = environment == null ? void 0 : environment.api) == null ? void 0 : _c.addToNewList) == null ? void 0 : _d.headers["client-id"][localeModuleKey];
      const config = {
        headers: {
          Authorization: authCookie,
          "client-id": clientid
        },
        timeout: (_f = (_e = environment == null ? void 0 : environment.api) == null ? void 0 : _e.addToNewList) == null ? void 0 : _f.timeout
      };
      try {
        const response = await fetch(url, config);
        const jsonResponse = await response.json();
        return jsonResponse;
      } catch (error) {
        throw error;
      }
    },
    getBingAutosuggest: (q, ul, cf) => {
      const url = `${environment.api.bingAutosuggest.endpoint}?query=${q}&includeEntityTypes=${environment.api.bingAutosuggest.entityTypes}&ul=${ul},${environment.api.bingAutosuggest.confidenceRadius}&cf=${cf}&maxResults=${environment.api.bingAutosuggest.maxResults}&key=${environment.api.bingAutosuggest.apiKey}`;
      const requestInit = {
        headers: {}
      };
      return cachingFetcher(
        url,
        requestInit,
        // environment.api.bingAutosuggest.timeout
        DEFAULT_TIMEOUT,
        false
      ).then((resp) => resp);
    },
    getBingLocation: (q) => {
      const url = `${environment.api.bingLocation.endpoint}?q=${q}&maxResults=${environment.api.bingLocation.maxResults}&key=${environment.api.bingLocation.apiKey}`;
      const requestInit = {
        headers: {},
        method: "GET"
      };
      return cachingFetcher(url, requestInit, DEFAULT_TIMEOUT).then(
        (resp) => resp
      );
    },
    getBrandfolderData: async (url, clientId) => {
      const requestInit = {
        method: "GET",
        headers: {
          "client-identifier": clientId || ""
        }
      };
      return cachingFetcher(
        url,
        requestInit,
        DEFAULT_TIMEOUT,
        true,
        6e5
        // 10 minutes
      ).then((resp) => resp);
    },
    getPdpVariants: (locale, slug) => {
      const url = `/api/pdp-variants?locale=${locale}&slug=${slug}`;
      const requestInit = {
        method: "GET"
      };
      return cachingFetcher(
        url,
        requestInit,
        DEFAULT_TIMEOUT,
        true,
        18e5
      ).then((resp) => resp);
    },
    getBatchApiData: async (url, requestInit) => {
      return cachingFetcher(
        url,
        requestInit,
        DEFAULT_TIMEOUT,
        true,
        12e4
      ).then((resp) => resp);
    },
    getCheckoutWarehouse: async (warehouseId, warehouseDrawer, itemType, pageName, orderitemid) => {
      const body = {};
      const requestInit = {
        body,
        headers: {},
        method: "POST",
        withCredentials: true
      };
      const domainUrl = window.location.origin;
      const url = `${domainUrl}${environment.api.warehouseUpdateService.endpoint}?warehouseId=${warehouseId}&warehouseDrawer=${warehouseDrawer}&itemType=${itemType}&pageName=${pageName}&orderItemId=${orderitemid}`;
      return cachingFetcher(
        url,
        requestInit,
        DEFAULT_TIMEOUT,
        false
      ).then((resp) => resp);
    },
    getDistributionCenters: (destinationState, destinationPostalCode) => {
      var _a, _b, _c, _d;
      let url = `${environment.api.locationCatalogAPIService.endpoint}?destinationPostalCode=${destinationPostalCode}`;
      if (destinationState) {
        url = `${url}&stateCode=${destinationState}`;
      }
      const requestInit = {
        headers: {
          "client-identifier": environment.api.locationCatalogAPIService.requiredRequestHeaders.client_identifier,
          "costco.env": (_b = (_a = environment.api.locationCatalogAPIService.requiredRequestHeaders) == null ? void 0 : _a.costco) == null ? void 0 : _b.env,
          "costco.service": (_d = (_c = environment.api.locationCatalogAPIService.requiredRequestHeaders) == null ? void 0 : _c.costco) == null ? void 0 : _d.service
        }
      };
      return cachingFetcher(
        url,
        requestInit,
        environment.api.locationCatalogAPIService.timeout,
        false
      ).then((resp) => resp);
    },
    getGeoServiceLocation: (q, country) => {
      const url = `${environment.api.geoCodeService.endpoint}?q=${q}${country ? `&country=${country}` : ""}`;
      const requestInit = {
        headers: { ...environment.api.geoCodeService.headers },
        method: "GET"
      };
      return cachingFetcher(
        url,
        requestInit,
        environment.api.geoCodeService.timeout
      ).then(
        (resp) => resp
      );
    },
    businessDeliveryZipValidation: (zipCode, currentZipCode, isInitiatedFromChangeAddressType) => {
      var _a, _b, _c, _d;
      const SITE = process.env.NEXT_PUBLIC_SITE;
      if (environment.api.businessDeliveryZipValidationAPI) {
        const url = `${environment.api.businessDeliveryZipValidationAPI.endpoint}`;
        const data = {
          zipCodeFormDeliveryZipCode: zipCode,
          currentZipCode: decodeURIComponent(currentZipCode || ""),
          redirectURL: "SetDeliveryZip",
          submitButton: "form-SetDeliveryZip",
          checkoutPage: "SetDeliveryZip",
          // these two values are here just to match legacy usage
          userSelectionDeliveryMethod: "",
          isInitiatedFromChangeAddressType: isInitiatedFromChangeAddressType ? true : ""
        };
        if ((_a = environment.api.businessDeliveryZipValidationAPI.requiredRequestParams[SITE]) == null ? void 0 : _a.storeId) {
          data["storeId"] = `${(_b = environment.api.businessDeliveryZipValidationAPI.requiredRequestParams[SITE]) == null ? void 0 : _b.storeId}`;
        }
        if ((_c = environment.api.businessDeliveryZipValidationAPI.requiredRequestParams[SITE]) == null ? void 0 : _c.catalogId) {
          data["catalogId"] = `${(_d = environment.api.businessDeliveryZipValidationAPI.requiredRequestParams[SITE]) == null ? void 0 : _d.catalogId}`;
        }
        const formBody = new URLSearchParams(data).toString();
        const requestInit = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
          },
          method: "POST",
          body: formBody
        };
        return cachingFetcher(
          url,
          requestInit,
          environment.api.businessDeliveryZipValidationAPI.timeout,
          false
        ).then(
          (resp) => resp
        );
      }
    },
    businessDeliveryBrowse: (locale, zipCode, currentZipCode = "", userSelectionDeliveryMethod = "") => {
      var _a, _b, _c, _d;
      const SITE = process.env.NEXT_PUBLIC_SITE;
      if (environment.api.businessDeliveryBrowseAPI) {
        const langId = Object.keys(languageMap).find((key) => languageMap[key] === locale);
        const url = `${environment.api.businessDeliveryBrowseAPI.endpoint}`;
        const data = {
          redirectURL: "SetDeliveryZip",
          submitButton: "form-SetDeliveryZip",
          checkoutPage: "SetDeliveryZip",
          langId: langId || "-24",
          zipCodeFormDeliveryZipCode: zipCode,
          userSelectionDeliveryMethod
        };
        if (zipCode) {
          data.currentZipCode = decodeURIComponent(
            currentZipCode || ""
          );
        }
        if ((_a = environment.api.businessDeliveryBrowseAPI.requiredRequestParams[SITE]) == null ? void 0 : _a.storeId) {
          data["storeId"] = `${(_b = environment.api.businessDeliveryBrowseAPI.requiredRequestParams[SITE]) == null ? void 0 : _b.storeId}`;
        }
        if ((_c = environment.api.businessDeliveryBrowseAPI.requiredRequestParams[SITE]) == null ? void 0 : _c.catalogId) {
          data["catalogId"] = `${(_d = environment.api.businessDeliveryBrowseAPI.requiredRequestParams[SITE]) == null ? void 0 : _d.catalogId}`;
        }
        const formBody = new URLSearchParams(data).toString();
        const requestInit = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
          },
          method: "POST",
          body: formBody,
          credentials: "include"
        };
        return cachingFetcher(
          url,
          requestInit,
          environment.api.businessDeliveryBrowseAPI.timeout,
          false
        ).then(async (resp) => {
          const browseAPIResponse = resp;
          let city, state, country;
          if (agent) {
            if (!browseAPIResponse.errorMessage && browseAPIResponse.SetDeliveryZip) {
              try {
                const geoServiceResults = await agent.getGeoServiceLocation(
                  resp.SetDeliveryZip
                );
                const firstGeoServiceResult = geoServiceResults == null ? void 0 : geoServiceResults[0];
                city = firstGeoServiceResult == null ? void 0 : firstGeoServiceResult.city;
                country = firstGeoServiceResult == null ? void 0 : firstGeoServiceResult.country;
                state = firstGeoServiceResult == null ? void 0 : firstGeoServiceResult.stateProvinceAbbreviation;
              } catch (err) {
              }
            }
          }
          return {
            ...browseAPIResponse,
            city,
            state,
            country
          };
        });
      }
    },
    getMegaMenu: async (megaMenuServiceConfig, loc, isDistributionCenterEmpty, _locale, userLocation, userPostal) => {
      const {
        endpoint,
        required_request_parameters,
        required_request_headers,
        timeout,
        disablecache
      } = megaMenuServiceConfig;
      const { chdmegamenu = true } = required_request_parameters ?? {};
      let locale;
      if (typeof (required_request_parameters == null ? void 0 : required_request_parameters.locale) === "string") {
        locale = required_request_parameters == null ? void 0 : required_request_parameters.locale;
      } else {
        locale = required_request_parameters == null ? void 0 : required_request_parameters.locale[_locale.substring(0, 2)];
      }
      const queryParams = new URLSearchParams({ locale: `${locale}` });
      if (loc) {
        let locValue = `${loc}`;
        if (locValue.includes("-ND")) {
          locValue = locValue.replace("-ND", "");
          queryParams.append("loc", locValue);
          queryParams.append("nationalDelivery", "true");
        } else {
          queryParams.append("loc", locValue);
        }
      }
      if (isDistributionCenterEmpty)
        queryParams.append("bypasslocation", "1");
      if (chdmegamenu)
        queryParams.append("chdmegamenu", `${chdmegamenu}`);
      if (userLocation) queryParams.append("userLocation", userLocation);
      if (userPostal) queryParams.append("userPostal", userPostal);
      const url = `${endpoint}?${queryParams}`;
      const requestInit = {
        headers: required_request_headers,
        method: "GET"
      };
      return cachingFetcher(
        url,
        requestInit,
        timeout,
        !disablecache
      ).then((resp) => resp);
    },
    getMembershipStatus: (accessToken) => {
      var _a, _b;
      const url = environment.api.membershipStatus.endpoint;
      const costcoHeaderEnv = environment.api.membershipStatus.headers["costco.env"];
      const costcoHeaderService = environment.api.membershipStatus.headers["costco.service"];
      const hostName = typeof window !== "undefined" ? (_b = (_a = window == null ? void 0 : window.location) == null ? void 0 : _a.hostname) == null ? void 0 : _b.replace(
        /\.costco\.com|\.costco\.ca/gi,
        ""
      ) : "default";
      const costcoHeaderEnvVal = typeof costcoHeaderEnv === "string" ? costcoHeaderEnv : costcoHeaderEnv == null ? void 0 : costcoHeaderEnv[hostName];
      const costcoHeaderServiceVal = typeof costcoHeaderService === "string" ? costcoHeaderService : costcoHeaderService == null ? void 0 : costcoHeaderService[hostName];
      const requestInit = {
        headers: {
          ...environment.api.membershipStatus.headers,
          "costco.env": costcoHeaderEnvVal,
          "costco.service": costcoHeaderServiceVal,
          "costco-x-authorization": `Bearer ${accessToken}`
        }
      };
      return cachingFetcher(
        url,
        requestInit,
        DEFAULT_TIMEOUT,
        false
      ).then(
        (resp) => resp
      );
    },
    getWarehousesByLatLng: (latitude, longitude, locale, clearCacheEntry = false, filters, limit = environment.api.locatorService.maxWarehousesCount) => {
      const { region: regionParam, ...filtersWithoutRegion } = filters || {};
      const filterkeys = Object.keys(filtersWithoutRegion || {}).filter(
        (k) => {
          const value = filtersWithoutRegion == null ? void 0 : filtersWithoutRegion[k];
          return Boolean(value);
        }
      );
      const filtersQueryParameter = !isEmpty(filterkeys) ? `&filters=${filterkeys.toString()}` : "";
      const regionQueryParameter = regionParam ? `&region=${encodeURIComponent(regionParam)}` : "";
      const clientId = environment.api.locatorService.clientId;
      const clientIdQuery = clientId ? `client_id=${clientId}&` : "";
      const headers = {};
      const source = {
        ...environment.api.locatorService.headers,
        "Accept-Language": locale
      };
      for (const key in source) {
        if (source[key] !== void 0) {
          headers[key] = source[key];
        }
      }
      const url = `${environment.api.locatorService.endpoint}?${clientIdQuery}latitude=${round(latitude, 3)}&longitude=${round(
        longitude,
        3
      )}${filtersQueryParameter}${regionQueryParameter}&limit=${limit}&openingDate=${openingDate()}`;
      const requestInit = {
        headers: {
          // ...environment.api.locatorService.headers,
          ...headers,
          "Accept-Language": locale
        },
        method: "GET"
      };
      return cachingFetcher(
        url,
        requestInit,
        DEFAULT_TIMEOUT,
        !clearCacheEntry
      ).then(
        (resp) => resp
      );
    },
    getWarehouse: async (locale, warehouseId) => {
      const clientId = environment.api.locatorService.clientId;
      const clientIdQuery = clientId ? `client_id=${clientId}` : "";
      const headers = {};
      const source = {
        ...environment.api.locatorService.headers,
        "Accept-Language": locale
      };
      for (const key in source) {
        if (source[key] !== void 0) {
          headers[key] = source[key];
        }
      }
      const endpointJsonRemoved = environment.api.locatorService.endpoint.replace(/\.json$/, "");
      const endpoint = `${endpointJsonRemoved}/${warehouseId}.json`;
      const url = `${endpoint}?${clientIdQuery}`;
      const requestInit = {
        headers: {
          ...headers,
          "Accept-Language": locale
        },
        method: "GET"
      };
      const resp = await cachingFetcher(
        url,
        requestInit,
        DEFAULT_TIMEOUT
      );
      return resp;
    },
    getWishLists: (authCookie, localeModuleKey) => {
      if (!localeModuleKey) {
        throw new Error("locale Module key has to be passed");
      }
      if (!authCookie) {
        throw new Error("Authorization cookie has to be passed");
      }
      const url = environment.api.getWishLists.endpoint;
      const clientid = environment.api.getWishLists.headers["client-id"][localeModuleKey];
      const config = {
        headers: {
          ...environment.api.getWishLists.headers,
          Authorization: authCookie,
          "client-id": clientid
        }
      };
      return cachingFetcher(
        url,
        config,
        environment.api.getWishLists.timeout,
        false
      ).then((resp) => resp);
    },
    getWishListsLegacy: async () => {
      var _a, _b, _c, _d, _e, _f;
      const url = (_b = (_a = environment == null ? void 0 : environment.api) == null ? void 0 : _a.getWishListsLegacy) == null ? void 0 : _b.endpoint;
      const requestInit = {
        credentials: "include",
        headers: (_d = (_c = environment == null ? void 0 : environment.api) == null ? void 0 : _c.getWishListsLegacy) == null ? void 0 : _d.headers,
        method: (_f = (_e = environment == null ? void 0 : environment.api) == null ? void 0 : _e.getWishListsLegacy) == null ? void 0 : _f.method
      };
      return cachingFetcher(
        url,
        requestInit,
        environment.api.getWishListsLegacy.timeout,
        false
      ).then((resp) => resp);
    },
    getZipByAddress: async (encodedFormData) => {
      try {
        const { endpoint } = environment.api.getZipByAddress;
        if (!endpoint) {
          console.error(
            "getZipByAddressResponse - endpoint is received"
          );
          return void 0;
        }
        const response = await fetch(
          `${endpoint}?formdata=${encodedFormData}`,
          {
            method: "POST"
          }
        );
        if (response.ok) {
          return response.json();
        }
      } catch (error) {
        console.log("error", error);
        {
          console.error("Error fetching getZipByAddress:", error);
        }
        return void 0;
      }
    },
    postAddToCartDetails: async (endpoint, params) => {
      const domainUrl = window.location.origin;
      const url = new URL(`${domainUrl}/${endpoint}`);
      Object.entries(params).forEach(([key, val]) => {
        url.searchParams.append(key, `${val}`);
      });
      const requestInit = {
        body: {},
        headers: {},
        method: "POST"
      };
      return cachingFetcher(
        url.toString(),
        requestInit,
        DEFAULT_TIMEOUT,
        false
      ).then((resp) => resp);
    },
    postAddToCartMultiItemsDetails: async (endpoint, params, body) => {
      const domainUrl = window.location.origin;
      const url = new URL(`${domainUrl}/${endpoint}`);
      Object.entries(params).forEach(([key, val]) => {
        url.searchParams.append(key, `${val}`);
      });
      const requestInit = {
        body: new URLSearchParams(
          body
        ).toString(),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        method: "POST"
      };
      return cachingFetcher(
        url.toString(),
        requestInit,
        DEFAULT_TIMEOUT,
        false
      ).then((resp) => resp);
    },
    // NEW LIST API
    saveToWishList: async (authCookie, quantity, itemNumber, selectedLists, localeModuleKey) => {
      var _a, _b, _c, _d, _e, _f;
      if (!localeModuleKey) {
        throw new Error("locale Module key has to be passed");
      }
      if (!authCookie) {
        throw new Error("Authorization cookie has to be passed");
      }
      const baseUrl = (_b = (_a = environment == null ? void 0 : environment.api) == null ? void 0 : _a.addToNewList) == null ? void 0 : _b.endpoint;
      const urls = selectedLists.map(
        (listItem) => `${baseUrl}${listItem.value}/entries`
      );
      const clientid = (_d = (_c = environment == null ? void 0 : environment.api) == null ? void 0 : _c.addToNewList) == null ? void 0 : _d.headers["client-id"][localeModuleKey];
      const body = JSON.stringify({
        comment: "",
        itemNumber,
        quantity,
        type: "CostcoItemListEntry"
      });
      const requestInit = {
        body,
        headers: {
          ...(_f = (_e = environment == null ? void 0 : environment.api) == null ? void 0 : _e.addToNewList) == null ? void 0 : _f.headers,
          Authorization: authCookie,
          "client-id": clientid
        },
        method: "POST"
      };
      const promises = urls.map((url) => fetch(url, requestInit));
      return Promise.all(promises).then(async (responses) => {
        const errorsFound = responses.filter(
          (response) => !response.ok
        );
        if (errorsFound.length) {
          const status = errorsFound[0].status;
          const statusText = errorsFound[0].statusText;
          throw new HttpError(
            status,
            statusText,
            `Network error: ${status} ${statusText}`
          );
        }
        const data = [];
        for (const response of responses) {
          const tempData = await response.json();
          data.push(tempData);
        }
        return data;
      }).catch((error) => {
        throw error;
      });
    },
    validateMembershipNumber: async (endpoint, membershipNumber) => {
      const domainUrl = window.location.origin;
      const url = new URL(`${domainUrl}/${endpoint}`);
      const body = `membershipId=${membershipNumber}`;
      const requestInit = {
        body,
        headers: {
          accept: "application/json, text/javascript, */*, q=0.01",
          "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
          priority: "u=1,i",
          "x-requested-with": "XMLHttpRequest"
        },
        method: "POST",
        credentials: "include"
      };
      return cachingFetcher(
        url,
        requestInit,
        DEFAULT_TIMEOUT,
        false
      ).then(
        (resp) => resp
      );
    },
    getWarehousesGasPrices: async (warehouseIds) => {
      var _a;
      const { endpoint, requiredRequestParameters } = (_a = environment == null ? void 0 : environment.api) == null ? void 0 : _a.getWarehousesGasPrices;
      if (!endpoint) {
        console.error(
          "getWarehousesGasPrices - endpoint wasn't received"
        );
        return [];
      }
      if (!requiredRequestParameters) {
        console.error(
          "getWarehousesGasPrices - requiredRequestParameters wasn't received"
        );
        return [];
      }
      const url = `${endpoint}?${requiredRequestParameters.warehouseid}=${warehouseIds.join("_")}`;
      const requestInit = {
        method: "GET"
      };
      return cachingFetcher(
        url,
        requestInit,
        DEFAULT_TIMEOUT,
        false
      ).then((resp) => resp);
    }
  };
  return agent;
};
export {
  getAgent
};
